import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "children"];
import { Flex } from '../../../components/Flex';
import { getVariantStyles } from './ToolBar.helpers';
import styled from 'foundations-theming/utils';
import { StyledLink } from '../Link/Link';
import { StyledToolBarGroup } from '../ToolBarGroup/ToolBarGroup';
import { StyledNav } from '../Breadcrumbs/Breadcrumbs';
import { Affordance as AutoSizedTextInputAffordance, StyledIconWrapper as AutoSizedTextInputIconWrapper } from '../AutoSizedTextInput/AutoSizedTextInput';
import { ToolBarContext } from './ToolBarContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledToolBar = styled.div.withConfig({
  displayName: "ToolBar__StyledToolBar",
  componentId: "sc-1vaenfa-0"
})(({
  theme,
  $use
}) => {
  // default and dark are the same: both uses are accepted here for backwards compatibility
  const isDefault = $use === 'default' || $use === 'dark';
  return Object.assign({
    [`& ${StyledNav}`]: {
      // using the size of the text to make sure this is perfectly aligned
      lineHeight: theme.typography['body-100'].fontSize
    }
  }, $use !== 'filter-bar' && $use !== 'tabs' && {
    [`& ${StyledLink}`]: {
      fontSize: theme.typography['heading-50'].fontSize,
      ':focus': {
        // link focus box shadow doesn't play nice with the toolbar
        boxShadow: 'none!important'
      }
    }
  }, isDefault && {
    [`& ${StyledToolBarGroup}, & ${AutoSizedTextInputAffordance}, & ${AutoSizedTextInputIconWrapper}`]: {
      color: theme.color['text-core-on-fill-default']
    }
  }, !isDefault && {
    [`& ${StyledToolBarGroup}, & ${AutoSizedTextInputAffordance}, & ${AutoSizedTextInputIconWrapper}`]: {
      color: theme.color['text-core-default']
    }
  });
});
export const ToolBar = _ref => {
  let {
      use = 'default',
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const variantStyles = getVariantStyles(use);
  return /*#__PURE__*/_jsx(ToolBarContext.Provider, {
    value: {
      use
    },
    children: /*#__PURE__*/_jsx(StyledToolBar, {
      $use: use,
      children: /*#__PURE__*/_jsx(Flex, Object.assign({
        role: "group",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        inlineSize: "100%",
        justifyContent: "space-between",
        paddingInline: "200"
      }, variantStyles, rest, {
        children: children
      }))
    })
  });
};
ToolBar.displayName = 'ToolBar';